import {StateProgram} from '../../../../shared/models/socialSupport/stateProgram';
import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {AppActions} from '../../../actions';

export interface StateProgramsState {
  programs: StateProgram[] | null;
}

const initialState: StateProgramsState = {
  programs: null,
};

export const stateProgramSlice = createSlice({
  name: '@@eskso/socialSupport/statePrograms',
  initialState,
  reducers: {
    setStatePrograms: (state, action: PayloadAction<StateProgram[]>) => {
      return {
        ...state,
        programs: action.payload,
      };
    },
  },
  extraReducers: {
    [AppActions.Reset]: () => {
      return initialState;
    },
  },
});

export const statePrograms = stateProgramSlice.reducer;
